<template>
	<div class="page-default">
		<TitleBar title="Terms &amp; Conditions" />
        <div class="page-content">
            
            <p>1. I am 18 years of age or older.</p>
            <p>2. I am responsible for obeying all applicable enforcement mechanisms, including, but not limited to federal, state, municipal, and tribal statutes, rules, regulations, ordinances, and judicial decisions, any applicable Presidential Executive Orders, including compliance with all applicable licensing requirements.</p>
            <p>3. I will not use Armslist.deals for any illegal purpose.</p>
            <p>4. If I am at all unsure about firearm sales or transfers, I will contact the Bureau of Alcohol, Tobacco, Firearms, and Explosive at 1-800-ATF-GUNS and visit the ATF website at http://www.atf.gov.</p>
            <p>5. I will help to ensure the overall openness and accessibility of the site to all users through a peer-review process. I understand that failure to adhere to proper internet protocol and etiquette may result in severe corrective action.</p>
            <p>6. ARMSLIST may edit or remove information from the site without notice.</p>
            <p>7. If I violate these terms, ARMSLIST may permanently remove me from the site or, depending on the nature and severity of the violation, avail itself of such remedies as are prescribed by law. Whilst ARMSLIST ABSOLUTELY BELIEVES AND CHAMPIONS "the right of the people to keep and bear Arms," ARMSLIST will comply with federal, state, municipal, and tribal law enforcement entities pursuant to the Constitution of the United States and Due Process of Law.</p>
            <p>8. I take responsibility for my actions whilst using Armslist.deals. I also take responsibility for any and all of my actions related to, or resulting from, my use of Armslist.deals. Further, I am solely responsible for any and all consequences of such my actions.</p>
            <p>9. I indemnify and hold harmless ARMSLIST and all of its owners, directors, officers, employees, and agents for any and all loss, harm, damage, costs, liability, and expense caused to them, whether intentionally or unintentionally, by my use of Armslist.deals, including but not limited to direct or indirect results of violations of any and all applicable laws.</p>
            <p>10. ARMSLIST may make changes to these terms at any time without notifying me. As a user, I am solely responsible for reading the most current version of the terms and conditions.</p>
            <p>11. By clicking "Accept," ("I agree"), I electronically represent ("sign") that I agree to the above terms and further certify that I have read, and completely agree, to be legally bound by the ARMSLIST Terms of Use</p>


        </div>
	</div>
</template>

<script>
import TitleBar from '../components/TitleBar.vue';

//
export default {
	components: {
		TitleBar
	},
	data: function() {
		return {
            isLoading: true,
            totalDeals: 0,
			deals: false
		}
	},
	computed: {
		pageTitle() {
			return ["Deals tagged", this.$route.params.tag].join(" ");
		}
	},
	methods: {

        getParams(route) {
            try {

                //if we have a custom collection for this tag, use it instead
                if( typeof route.meta.collections[route.params.tag] == 'object' ) {
                    return route.meta.collections[route.params.tag];
                }

                //
                return {
                    tag: route.params.tag
                };

            }catch(e) {
                return {
                    tag: route.params.tag
                }
            }
        }

    }
};
</script>

<style lang="scss">
</style>